import type { ArenaDefinition } from "@arena/shared";
import { GREYBOX_ARENA } from "./greybox.ts";
import { COLOSSEO_ARENA } from "./colosseo.ts";
import { INFERNO_ARENA } from "./inferno.ts";

export { COLOSSEO_ARENA, GREYBOX_ARENA, INFERNO_ARENA };
export * from "./museum.ts";
export {INFERNO_LAYOUT,infernoEdge} from './inferno.ts';

export const ARENAS: Readonly<Record<string, ArenaDefinition>> = {
  [GREYBOX_ARENA.id]: GREYBOX_ARENA,
  [COLOSSEO_ARENA.id]: COLOSSEO_ARENA,
  [INFERNO_ARENA.id]: INFERNO_ARENA,
};

/** The first map (D39). The grey box stays for tests; the Colosseo (D38) as a second map for later. */
export const DEFAULT_ARENA_ID = INFERNO_ARENA.id;

/** The maps a host may pick in the register (D49); the grey box stays for tests. */
export const MAP_CHOICES: readonly string[] = [INFERNO_ARENA.id, COLOSSEO_ARENA.id];

export function getArena(id: string): ArenaDefinition {
  const arena = ARENAS[id];
  if (!arena) throw new Error(`Arena sconosciuta: ${id}`);
  return arena;
}
